import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import ReactToPrint from "react-to-print";
import { useAppDispatch, useAppSelector } from "../../../_App/Redux/hooks";
import {
  getOrderByIdApi,
  order,
} from "../../../_App/Redux/Slices/Orders/OrderSlice";
import {
  findPaymentsByOrderApi,
  findPaymentsByTicketApi,
  findreglementsAPi,
  listOperationsByPaymentMethod,
} from "../../../_App/Redux/Slices/payments/PaymentSlice";
import {
  Ticket,
  getTicketById,
} from "../../../_App/Redux/Slices/tickets/TicketSlice";
import { Printer, Model, WebUSB } from "escpos-buffer";
import { parametrageCaisse } from "../../../_App/Redux/Slices/AppParametrages/caisseParametrages/caisseParametrageSlice";
import Barcode from "react-barcode";
import {
  currentCaisse,
  SelectedOrganisation,
  SelectedOrganisationId,
  selectUser,
} from "../../../_App/Redux/Slices/Auth/authSlice";
import {
  calculateRemise,
  exportExcel,
  formatDate,
  formatTime,
} from "../../../_App/Helpers/helpers";
import { VendeursByCode } from "../../../_App/Redux/Slices/users/vendeurSlice";
import { useTranslation } from "react-i18next";
import {
  getJournalCaisseByIdApi,
  Journal,
  updateJournal,
} from "../../../_App/Redux/Slices/journalCaisse/journalCaisseSlice";
import {
  findMouvementsCaisseByJournalApi,
  ListJournalMouvementsCaisse,
  listMouvementsCaisseCommandeBySession,
} from "../../../_App/Redux/Slices/mouvementCaisse/MouvementCaisseSlice";
import { MouvementCaisseType } from "../../../_App/Types/Entites/MouvementCaisseType";
import Swal from "sweetalert2";
import { OrderType } from "../../../_App/Types/Entites/Orders/OrderType";

const TicketDeVentesJournal = ({ ShowModal, setShowModal, id }: any) => {
  const dispatch = useAppDispatch();
  const currentOrganisation = useAppSelector(SelectedOrganisationId);
  const journal = useAppSelector(Journal);
  const { t } = useTranslation();
  const sessionXorderMouvements = useAppSelector(
    listMouvementsCaisseCommandeBySession
  );
  const mouvementsCaisseParJournal = useAppSelector(
    ListJournalMouvementsCaisse
  );
  const [filtre, setFiltre] = useState({
    organisation: undefined,
    dateFin: undefined,
    dateDebut: undefined,
    listcaissiers: [],
    listvendeur: [],
    status: undefined,
    type: undefined,
    numOrder: undefined,
    index: 1,
    keyword: "",
    societe_id: undefined,
  });
  const [reglements, setReglements] = useState<Record<string, number>>({});
  useEffect(() => {
    const fetch = async () => {
      if (currentOrganisation && id) {
        dispatch(findMouvementsCaisseByJournalApi(id));
        dispatch(getJournalCaisseByIdApi(id));
        const res = await dispatch(
          findreglementsAPi({ ...filtre, journal_id: id })
        );
        if (res.payload.data?.payments)
          setReglements(res.payload.data?.payments);
      }
    };
    fetch();
  }, [dispatch, ShowModal]);
  const parametrages = useAppSelector(parametrageCaisse);

  interface DataRow {
    date: string;
    client: string;
    numFacture: string;
    article: string;
    designation: string;
    qte: number;
    prixNetHT: number;
    prixNetTTC: number;
    societe: string;
  }

  const ordersArticlesList = (data: any) => {
    if (journal && data && data[0] && data[0][1]) {
      console.log("data", data);
      
      let combined = {};
      data.map((item: any) => {
        console.log("item", item)
        combined = { ...combined, ...item[1] };
      });

      const uniqueOrdersMap: OrderType[] = [];

      Object.values(combined).forEach((paymentArray: any) => {
        paymentArray.forEach((payment: any) => {
          const order = payment.order_id;
          if (order && !uniqueOrdersMap.some((o) => o._id === order._id)) {
            uniqueOrdersMap.push(order);
          }
        });
      });

      return uniqueOrdersMap;
    }
  };
  const result = ordersArticlesList(Object.entries(sessionXorderMouvements));
  const totalNetSum = result?.reduce(
    (acc, order) =>
      order.status === "Payée" ? acc + Number(order.totalNet || 0) : acc + 0, //(acc, order) => acc + Number(order.totalNet || 0),
    0
  );
  const componentRef = useRef<HTMLDivElement>(null);
  const handlePrint = () => {
    // Access the hidden iframe and trigger its print method
    const printFrame = document.getElementById(
      "print-frame"
    ) as HTMLIFrameElement | null;
    if (printFrame) {
      printFrame.contentWindow?.print();
    }
  };
  return (
    <Modal
      show={ShowModal}
      onHide={() => setShowModal(false)}
      className="ticket-modal"
      style={{ display: "flex", justifyContent: "center" }}
      size="lg"
    >
      <div ref={componentRef}>
        <div className="container-ticket" id="print-content ">
          <div className="receipt_header">
            <h1 onClick={() => console.log(result)}>
              Ticket de Ventes Journal <span>{journal.societe?.nom}</span>
            </h1>
            <h2>
              {journal?.organisation_id?.nom || ""}{" "}
              <span>{"Tel: " + (journal.societe?.tel || "")}</span>
            </h2>
          </div>

          <div className="row">
            <div className="col-6" style={{ fontSize: "12px" }}>
              <p className="inv-street-addr mb-0">Numero</p>
              <p className="inv-email-address"> {journal?.code_journal}</p>
            </div>

            <div className="col-6" style={{ fontSize: "12px" }}>
              <p className="inv-street-addr mb-0">Caissier</p>
              <p className="inv-email-address">
                {(journal?.user_id?.nom || "") +
                  " " +
                  (journal?.user_id?.prenom || "")}
              </p>
            </div>
          </div>

          <div className="receipt_body">
            {/* <div className="date_time_con">
              <div className="date">
                {" "}
                {formatDate({
                  date: journal?.date?.toISOString(),
                })}{" "}
              </div>
              <div className="time">
                {" "}
                {formatTime({ date: new Date().toISOString() })}
              </div>
            </div> */}

            <div className="ticket-items">
              <table
                style={{
                  whiteSpace: "normal",
                  borderBottom: "1px dashed #000",
                }}
              >
                {/* <thead>
                  <tr>
                    <th>Désignation</th>
                    <th>Total</th>
                  </tr>
                </thead> */}
                <tbody>
                  {result?.map((order: OrderType) => (
                    <React.Fragment key={order._id}>
                      <tr>
                        <td colSpan={2} style={{ textAlign: "left" }}>
                          <strong>{order.order_number +'-'+ order.status}</strong>
                        </td>
                      </tr>
                      {order.items.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <b>{item.quantity}x </b>
                            {item.article.titre.fr}{" "}
                            {item.article.caracteristiques &&
                            item.article.caracteristiques.length
                              ? item.article.caracteristiques.map(
                                  (caracteristique: any, i: number) => (
                                    <span key={i}>
                                      {caracteristique.value.libelle
                                        ? caracteristique.value.libelle
                                        : caracteristique.value}{" "}
                                    </span>
                                  )
                                )
                              : null}
                          </td>
                          <td>
                            {item.quantity < 0
                              ? Number(item.prixNet).toFixed(3)
                              : Number(item.prix_total).toFixed(3)}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td>
                          {" "}
                          <strong>Total Net</strong>
                        </td>

                        <td>
                          <strong>{Number(order.totalNet)?.toFixed(3)}</strong>{" "}
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td style={{ textAlign: "left" }}>
                      <strong>Total Général</strong>
                    </td>
                    <td>
                      <strong>{totalNetSum?.toFixed(3)}</strong>
                    </td>
                  </tr>
                  {reglements &&
                    Object.entries(reglements).map(([key, value]) => (
                      <tr key={key}>
                        <td>{key}</td>
                        <td>{value.toFixed(3)}</td>
                      </tr>
                    ))}
                </tfoot>
              </table>
              {/* {Object.entries(orderItemsGroupedByTva).map(
                ([key, items]: any) => (
                  <div
                    className="row"
                    key={key}
                    style={{
                      borderBottom: "1px dashed #000",
                      margin: "2px",
                    }}
                  >
                    <div className="col-3" style={{ fontSize: "12px" }}>
                      <p className="inv-street-addr mb-0">Taxe</p>
                      <p className="inv-email-address">TVA</p>
                    </div>
                    <div className="col-3" style={{ fontSize: "12px" }}>
                      <p className="inv-street-addr mb-0">Base HT</p>
                      <p className="inv-email-address">
                        {items
                          .reduce(
                            (acc: any, val: any) =>
                              acc +
                              val.article.prix_vente_ht * val.quantity -
                              val.article.prix_vente_ht *
                                val.quantity *
                                (val.remise / 100) -
                              val.article.prix_vente_ht *
                                val.quantity *
                                (val.remiseClient / 100),
                            0
                          )
                          .toFixed(3)}
                      </p>
                    </div>
                    <div className="col-3" style={{ fontSize: "12px" }}>
                      <p className="inv-street-addr mb-0">Taux</p>
                      <p className="inv-email-address">
                        {key === "undefined" ? 0 : key}
                      </p>
                    </div>
                    <div className="col-3" style={{ fontSize: "12px" }}>
                      <p className="inv-street-addr mb-0">Montant</p>
                      <p className="inv-email-address">
                        {(
                          (items.reduce(
                            (acc: any, val: any) =>
                              acc + val.article.prix_vente_ht,
                            0
                          ) *
                            Number(key)) /
                          100
                        ).toFixed(3)}
                      </p>
                    </div>
                  </div>
                )
              )} */}
            </div>
            {/* <div
              className="barcode"
              style={{ display: "flex", justifyContent: "center" }}
            >
              {ticket_id && ticket && ticket.main_order && (
                <Barcode value={ticket?.ticket_order.order_number} />
              )}
            </div> */}
          </div>
          {/* <div className="receipt-footer mt-2 ">
            <p style={{ textAlign: "center" }}>
              {parametrage &&
                parametrage.message_promo !== null &&
                parametrage.message_promo.split("\n").map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
            </p>
          </div> */}
        </div>
      </div>
      <ReactToPrint
        trigger={() => (
          <Button
            variant="contained"
            color="primary"
            onClick={handlePrint}
            className="btn-info"
          >
            Print
          </Button>
        )}
        content={() => componentRef.current}
      />
      <iframe
        id="print-frame"
        title="print-frame"
        style={{ display: "none" }}
        onLoad={() => handlePrint()}
      />
    </Modal>
  );
};

export default TicketDeVentesJournal;
